import React from 'react';
import I18n from '@utils/i18n';
import { SelectInput, Button } from '@ui';
import './ClearableSelectStyles.scss';
function ClearableSelect({ id, label, options, value, onChange, onClear, showSearch = false, disabled = false }) {
    const hasValue = value !== '' && value !== undefined;
    return (React.createElement("div", { className: `pc-edit__clearable-select${hasValue && !disabled ? ' pc-edit__clearable-select--has-value' : ''}` },
        React.createElement(SelectInput, { id: id, label: label, options: options, value: value, onChange: onChange, showSearch: showSearch, disabled: disabled }),
        hasValue && !disabled && (React.createElement(Button, { className: "pc-edit__clearable-select-btn", onClick: (e) => {
                e.stopPropagation();
                onClear();
            }, "aria-label": I18n.t('generic.clear') },
            React.createElement("i", { className: "fa-light fa-xmark" })))));
}
export default ClearableSelect;
